export default __webpack_public_path__ + "static/media/living-sk-logo-light-bg.52d658b5.svg";